import {Component, Injector, Input, OnInit} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {ParameterService} from "../../_services/parameter.service";
import {FileStorageService} from "../../_services/filestorage.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {AdminService} from "../dashboard/services/admin.service";
import {AdminUploadCeuCreditModal} from "./modals/upload-ceu-credit.modal";

@Component({
    selector: 'admin-wallet-ceu',
    templateUrl: './user-man-ceu-wallet.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class UserManCeuWalletComponent extends BasePageComponentDirective<any> implements OnInit {
    userCEUs: any[] = [];
    docTypes: any = {};
    userId: any = null;
    requestingTranscript: boolean;
    @Input() user: any;
    populate = true;
    constructor(
        injector: Injector,
        private adminService: AdminService,
        private parameterService: ParameterService,
        private fileStorageService: FileStorageService,
    ) {
        super(injector);
    }
    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';
        this.populate = true;
        this.pageQuery.columns = ['certificationTitle'];
        this.adminService.getUserCEUs(this.pageQuery, this.userId).then(r => {
            this.userCEUs = r.content;
            this.page.emit(r);
            this.populate = false;
        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.docTypes = await this.parameterService.getParameterByName("DOCUMENT_TYPE");
        this.userId = this.activatedRoute.snapshot.params.id;
        this.query();
    }

    downloadCert(d: any) {
        this.fileStorageService.getAdminCertificationDocumentUrl(d.documentId, d.fileName, this.user.id);
    }

    deleteCert(d: any) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                buttonOkLabel: 'Yes, Delete',
                buttonCancelLabel: 'Cancel',
                message: ``,
                subMessage: `Are you sure you want to delete "${d.certificationTitle}" from user wallet? This action cannot be undone.`,
                theme: 'dark'
            }
        })

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.fileStorageService.deleteAdminCertificationDocument(d.documentId, this.user.id).then(_ => {
                    this.query();
                    this.snackBar.open('Document has been deleted successfully', null, {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'right'
                    });

                })
            }
        });
    }

    editCert(d: any) {
        console.log(d);
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(AdminUploadCeuCreditModal, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                mode: 'edit',
                documentId: d.documentId,
                certificationId: d.certificationId,
                documentType: d.documentType,
                activity: d.providerActivityId,
                earnedCredit: d.earnedCredit,
                activityResponse: d.activityResponse,
                isAdmin: true,
                userId: this.user.id
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.query();
            }
        })
    }

    viewCert(d: any) {
        console.log(d);
        this.router.navigate([`office/user/ceu-upload/${d.documentId}/${this.user.id}`]).then()
    }

    getTranscript() {

        this.requestingTranscript = true;
        this.adminService.getUserTranscript(this.user.id).then(data => {
            const url = window.URL.createObjectURL(data);
            const a = document.createElement('a');
            a.href = url;
            a.download = `transcript.pdf`;
            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            this.requestingTranscript = false;
        });
    }

    openModalAddCeuCredit() {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(AdminUploadCeuCreditModal, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                mode: 'new',
                isAdmin: true,
                userId: this.user.id
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.query();
            }
        })
    }

}
